import React from "react";
import Navbar from "./component/navigationBar/Navbar";
import Home from "./component/home/Home";
import Mission from "./component/mission/Mission";
// ...existing code...
import Footer from "./component/footer/Footer";
import PrivacyPolicy from "./component/footer/PrivacyPolicy";
import TermsOfService from "./component/footer/TermsOfService";
import DeleteAccount from "./component/footer/DeleteAccount";
// ...existing code...
import Rescue from "./component/features/Rescue";
import Adoption from "./component/features/Adoption";
import Missing from "./component/features/Missing";
import StrayNetwork from "./component/features/StrayNetwork";
import Coordination from "./component/features/Coordination";
import AppWorkflows from "./component/features/AppWorkflows";
import TrustSafety from "./component/features/TrustSafety";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SequenceCard from "./component/section/SequenceCard";
import SmartAppBanner from "./component/smartCta/SmartAppBanner";


// ...existing code...

function App() {
  return (
    <Router>
      <Navbar />
      <main className="app-content">
        <SmartAppBanner />
        <Routes>
          <Route path="/" element={
            <>
              <Home />
              <Mission />
              {/* <Impact /> */}
              {/* <Story /> */}
              <Rescue />
              <Adoption />
              <Missing />
              <StrayNetwork />
              <Coordination />
              <AppWorkflows />
              {/* <Options /> */}
              <SequenceCard />
              <TrustSafety />
            </>
          } />
          <Route path="/mission" element={<Mission />} />
          {/* <Route path="/impact" element={<Impact />} /> */}
          {/* <Route path="/story" element={<Story />} /> */}
          <Route path="/rescue" element={<Rescue />} />
          <Route path="/adoption" element={<Adoption />} />
          <Route path="/missing" element={<Missing />} />
          <Route path="/network" element={<StrayNetwork />} />
          <Route path="/coordination" element={<Coordination />} />
          <Route path="/features" element={<AppWorkflows />} />
          <Route path="/safety" element={<TrustSafety />} />
          {/* <Route path="/options" element={<Options />} /> */}
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;